import _ from 'lodash';

const _import = require('@/libs/util.import.' + process.env.NODE_ENV);

const routes = [
  {
    path: 'businessSetting',
    name: 'businessSetting',
    meta: {
      title: '业务设置',
    },
    component: _import('basicData/businessSetting.vue'),
  },
  {
    path: 'templateManagement',
    name: 'templateManagement',
    meta: {
      title: '模版管理',
    },
    component: _import('basicData/templateManagement.vue'),
  },
];

export default _.map(routes, r => ({
  ...r,
  path: `basicData/${r.path}`,
  meta: _.defaults({
    auth: true,
  }, r.meta),
}));
